export const getOtherAppearances = (id, guest, edges) => {
  let guestRegex = new RegExp(guest.replace(' | ', '|').replace(/[.]/g, '\\.'));
  return edges
    .filter((edge) => guestRegex.test(edge.node.guest))
    .filter((edge) => edge.node.id !== id);
};
